module.exports = __webpack_public_path__ + "static/media/composer-up-arrow.2aceea2a.svg";